export default "__VITE_ASSET__DwX_aO88__"